import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import difference from 'lodash/difference'
import classNames from 'classnames';
import some from 'lodash/some'

import { Steps } from 'primereact/steps';
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';

import Header from '@components/Header';
import GeneralForm from '@components/Section/Forms/General';
import ComponentsLayout from '@components/Section/Forms/ComponentsLayout';
import VisibilityForm from '@components/Section/Forms/Visibility';
import PreviewForm from '@components/Section/Forms/Preview';
import LoadingAction from '@components/LoadingAction';


import { CLEAR_VALUES_SECTION } from '@constants/actionType'
import { AuthorizedStatusInt, LANGUAGE_DEFAULT } from '@constants/general'

import { getSectionLayout, addSection, rejectSection, getSectionTree, updateStatusSection } from '@actions/sections';
import { setCatalogCurrentSectionTree } from '@actions/catalogs';
import { sendActionToBitacora  } from '@actions/bitacora';

import store from '@store'

class StepsSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      maxStep:0,
      btnSubmitLoading: false,
      loadingAction: false,
      loadingPage: true,
      componentsSelectedOrigin: [],
      justificationRemove: '',
      errorsRej: [],
      transactionNameOpt: '',
      showModal: {
        isVisible: false,
        title: '',
        children: null,
        textOk: '',
        textHide: '',
        actionOk: null,
        actionHide: () => {},
      },
    };
  }

  async componentDidMount() {
    const { history } = this.props
    if (history.location.state?.clearCache) {
      await store.dispatch({
        type: CLEAR_VALUES_SECTION,
      })
    }
    this.setState({loadingPage: false})
  }



  nexStep = async (data) => {
    const { step } = this.state
    this.setState({ btnSubmitLoading: true });
    if (step === 0) await this.validateMaxStepEditComponents()
    // if (step ===  2) return this.createLayouts()
    // const validateMaxStep = step + 1 > maxStep ? step + 1 : maxStep
    this.setState(prevState => ({maxStep: step + 1 > prevState.maxStep ? step + 1 : prevState.maxStep}))
    this.setState(prevState => ({step: prevState.step + 1}))
    this.setState({ btnSubmitLoading: false });
  }

  backStep = (data) => {
    this.setState({ btnSubmitLoading: true });
    this.setState(prevState => ({step: prevState.step - 1}))
    this.setState({ btnSubmitLoading: false });
  }

  createLayouts = async ({isLanding = true, status = AuthorizedStatusInt.STATUS_EDITION, justification = ""}) => {
    const { history, t, addSection, getSectionTree, setCatalogCurrentSectionTree, sendActionToBitacora, _general } = this.props
    this.setState({ loadingAction: true, btnSubmitLoading: true });
    console.log('justification', justification)

    const response = await addSection(isLanding, status)

    if (!response.status) {
      const { transactionNameOpt } = this.state
      const dataBitacora = {
        transactionName: transactionNameOpt || 'Seccion',
        reason: `${_general[LANGUAGE_DEFAULT].titleSeccion} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await getSectionTree()
      await setCatalogCurrentSectionTree()
      this.setState({ loadingAction: false, btnSubmitLoading: false });

      return confirmDialog({
        message: t('La operación se ha realizado de manera éxitosa'),
        header: t('Confirmación'),
        icon: 'pi pi-check-circle',
        acceptLabel: t('Continuar'),
        rejectClassName: 'hide-component',
        accept: () => history.push('/sections'),
        onHide: () => history.push('/sections')
      });
    }
    return this.setState({ loadingAction: false, btnSubmitLoading: false });
  }

  saveNewSection = (isLanding, justification) => {
    this.setState({transactionNameOpt: 'altaSeccion'}, () => {
      this.createLayouts({isLanding, status: AuthorizedStatusInt.STATUS_PENDING, justification})
    })
  }

  saveAndSendAuthorized = (isLanding, justification) => {
    this.setState({transactionNameOpt: 'envAutSeccion'}, () => {
      this.createLayouts({isLanding, status: AuthorizedStatusInt.STATUS_PENDING, justification})
    })
  }
  
  saveAndAutorized = (isLanding, justification) => {
    this.setState({transactionNameOpt: 'autSeccion'}, () => {
      this.createLayouts({isLanding, status: AuthorizedStatusInt.STATUS_AUTHORIZED, justification})
    })
    // AuthorizedStatusInt
  }

  saveSectionFilter = (justification) => {
    this.setState({transactionNameOpt: 'altaSeccion'}, () => {
      this.createLayouts({isLanding: false, justification})
    })
  }

  saveSectionTypeDocument = (isLanding, justification) => {
    this.setState({transactionNameOpt: 'altaSeccion'}, () => {
      this.createLayouts({isLanding: true, justification})
    })
  }

  isFormFieldValid = (name) =>
    !!(this.state.errorsRej[name]);

  getFormErrorMessage = (name) =>
    this.isFormFieldValid(name) && (
      <small className="p-error">{this.state.errorsRej[name]}</small>
    );

  onConfirmReject = () => {
    const { t } = this.props
    const children = (
      <div className="p-mt-2 p-fluid">
        <div className="p-col">
          <label className="">{t('Justificacion de rechazo')}</label>
        </div>
          <InputTextarea
            name="justificationRemove"
            onChange={(e) => this.setState({justificationRemove: e.target.value}, this.validateFieldsOnchange('justificationRemove', e.target.value))}
            rows={5}
            cols={30}
            className={classNames({
              'p-invalid': this.isFormFieldValid(`justificationRemove`),
            })}
          />
          {this.getFormErrorMessage(`justificationRemove`)}
      </div>
    )
    this.setState({
      showModal: {
        isVisible: true,
        title: t('Rechazar Sección'),
        textOk: t('Continuar'),
        textHide: t('Cancelar'),
        actionOk: () => this.onReject(),
        actionHide: () => this.onHideModal(),
        children,
      },
    });
  }

  onReject = async () => {
    const validate = await this.validateFieldsReject()
    if (some(validate, {})) return this.onConfirmReject()
    const { rejectSection, t, history } = this.props
    const response = await rejectSection()
    if(!response.status) {
      this.onHideModal()
      return confirmDialog({
        message: t('La operación se ha realizado de manera éxitosa'),
        header: t('Confirmación'),
        icon: 'pi pi-check-circle',
        acceptLabel: t('Continuar'),
        rejectClassName: 'hide-component',
        accept: () => history.push('/sections'),
        onHide: () => history.push('/sections')
      });
    }
  }

  validateFieldsOnchange = (name, value) => {
    const { errorsRej } = this.state
    if (errorsRej[name] && value) {
      delete errorsRej[name]
      this.setState({errorsRej}, this.onConfirmReject())
    }
  }

  validateFieldsReject = async () => {
    const { justificationRemove } = this.state
    let errorsRej = {}
    if (!justificationRemove) errorsRej = { ...errorsRej, 'justificationRemove': 'Justificacion de rechazo es requerido' }
    this.setState({errorsRej})
    return errorsRej
  }

  onHideModal = () => {
    this.setState({
      showModal: {
        isVisible: false,
        actionHide: () => {},
      },
    });
  };

  validateOnchangeStep = (e) => {
    const { maxStep } = this.state
    if (e.index > maxStep) return true
    return this.setState({step: e.index}) 
  }

  validateMaxStepEditComponents = () => {
    const { componentsSelectedOrigin } = this.state
    const { _componentsSelected } = this.props
    if (!componentsSelectedOrigin.length) this.setState({componentsSelectedOrigin: _componentsSelected})
    else {
      const differenceComponents = difference(_componentsSelected, componentsSelectedOrigin)
      if (differenceComponents.length) {
        this.setState({maxStep: 1, componentsSelectedOrigin: _componentsSelected})
      }
      // Si existen los mismas clases que en el origin
    }
  }

  render() {
    const { step, btnSubmitLoading, loadingPage, showModal, maxStep } = this.state;
    const { t } = this.props;

    const steps = [
      { label: t("Datos generales"), command: (event) => { this.validateOnchangeStep(event) } },
      { label: t("Plantillas"), command: (event) => { this.validateOnchangeStep(event) } },
      // { label: t("Visibilidad"), command: (event) => { this.validateOnchangeStep(event) } },
      { label: t("Vista Previa"), command: (event) => { this.validateOnchangeStep(event) } }
    ]

    const footerModal = (
      <div>
        {showModal.actionHide && (
          <Button label={showModal.textHide} onClick={showModal.actionHide} />
        )}
        {showModal.actionOk && (
          <Button label={showModal.textOk} onClick={showModal.actionOk} />
        )}
      </div>
    );

    const stepsRender = () => {
      if (step === 0) {
        return (
          <GeneralForm
            success={this.nexStep}
            // authorize={() => this.createLayouts({isLanding: false})}
            reject={this.onConfirmReject}
            finishAction={this.saveSectionFilter}
            finishActionIsLanding={this.saveSectionTypeDocument}
            // onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}

            authorize={this.saveAndAutorized}
            sendAuthorize={this.saveAndSendAuthorized}
          />
        );
      }
      if (step === 1) {
        return (
          <ComponentsLayout
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
            parentMaxStep={maxStep}
          />
        );
      }
      // if (step === 2) {
      //   return (
      //     <VisibilityForm
      //       success={this.nexStep}
      //       onBack={this.backStep}
      //       btnSubmitLoading={btnSubmitLoading}
      //     />
      //   );
      // }
      if (step === 2) {
        return (
          <PreviewForm
            success={this.saveNewSection}
            // authorize={this.nexStep}
            reject={this.onConfirmReject}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}

            authorize={this.saveAndAutorized}
            sendAuthorize={this.saveAndSendAuthorized}
          />
        );
      }
      return true;
    };

    if (loadingPage) return true
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t("Datos de la seccion")} linkText={t("Ir al listado")} to="/sections" />
          <div className="card">
            <div className="p-grid p-mb-2">
              <div className="p-col-12 p-my-1">
                <Steps model={steps} activeIndex={step} readOnly={false}/>
              </div>
            </div>

            {stepsRender()}
            {/* <button
              onClick={() => {
                this.setState({ step: step - 1 });
              }}
            >
              Click menos
            </button>
            <button
              onClick={() => {
                this.setState({ step: step + 1 });
              }}
            >
              Click mas
            </button> */}
          </div>
        </div>
        <Dialog
          header={showModal.title}
          visible={showModal.isVisible}
          breakpoints={{'960px': '80vw'}}
          style={{ width: '35vw' }}
          footer={footerModal}
          onHide={showModal.actionHide}
        >
          {showModal.children}
        </Dialog>
        { this.state.loadingAction && <LoadingAction/> }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  mainClass: state.section.mainClass,
  totalSteps: state.section.totalSteps,
  languagesCatalog: state.catalogs.languagesCatalog,


  _componentsAvailables: state.section.componentsAvailables,
  _componentsSelected: state.section.componentsSelected,
  _keysLenguages: state.catalogs.keysLenguages,
  _section: state.section,
  _general: state.section.general,
  layoutsHtml: state.section.layoutsHtml
});

const mapDispatchToProps = {
  getSectionLayout,
  addSection,
  rejectSection,
  getSectionTree,
  setCatalogCurrentSectionTree,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(StepsSection);
